import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import WorkersListComponent from './WorkersListComponent';
import TipAmount from './TipAmount';
import SelectRating from './SelectRating';
import WorkersPreviewPhotosList from './WorkersPreviewPhotosList';
import Close from '../../../common/ui/Close';
import { favStatuses } from '../../../../constants/workers';

export default class TipRateModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    workersList: PropTypes.array,
    isTipModal: PropTypes.bool.isRequired,
    isRateModal: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    submitAddingTips: PropTypes.func.isRequired,
    submitRatingWorkers: PropTypes.func.isRequired
  };

  state = {
    selectedWorkers: [],
    isSelectWorkersStep: true
  };

  clearForm = () => {
    this.setState({
      selectedWorkers: [],
      isSelectWorkersStep: true
    });
  };

  cancel = () => {
    this.props.closeModal();
    this.clearForm();
  };

  handleWorkerSelection = selectedWorker => {
    let { selectedWorkers } = this.state;
    const selectedWorkerIndex = selectedWorkers.findIndex(worker => worker.id === selectedWorker.id);
    if (selectedWorkerIndex < 0) {
      selectedWorkers.push(selectedWorker);
    } else {
      selectedWorkers.splice(selectedWorkerIndex, 1);
    }

    this.setState({ selectedWorkers });
  };

  selectAllWorkers = () => {
    const { workersList } = this.props;
    const allowSelectAll = workersList.length !== this.state.selectedWorkers.length;

    if (allowSelectAll) {
      this.setState({
        selectedWorkers: workersList
      });
    }
  };

  _mapWorkersById () {
    return this.state.selectedWorkers.map(worker => worker.id);
  };

  showNextStep = () => {
    this.setState({
      isSelectWorkersStep: false
    });
  };

  showWorkersSelect = () => {
    this.setState({
      isSelectWorkersStep: true
    });
  };

  addTips = tip_amount => {
    const workers = this._mapWorkersById();
    this.props.submitAddingTips({ tip_amount, workers }).then(() => this.clearForm());
  };

  rateWorkers = ratingData => {
    const workers = this._mapWorkersById();
    this.props.submitRatingWorkers({ ...ratingData, workers }).then(() => this.clearForm());
  };

  isWorkersToAddFavorite = () => this.state.selectedWorkers.some(worker => worker.fav_status !== favStatuses.favorite);

  render () {
    const { isOpen, workersList, isTipModal, isRateModal } = this.props;
    const { isSelectWorkersStep, selectedWorkers } = this.state;
    const selectedWorkersIds = this._mapWorkersById();
    return (
      <Modal isOpen={isOpen} centered>
        <div className='modal-header'>
          <div className='modal-title'>
            { isSelectWorkersStep ? 'Select Workers' : isTipModal ? 'Add Tip' : isRateModal ? 'Rate Workers' : null }
          </div>

          <Close onClick={this.cancel} />
        </div>

        <div className='modal-body'>
          { !isSelectWorkersStep && (
            <div className='form-group'>
              <button className='button button-cancel button-icon' onClick={this.showWorkersSelect}>
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
            </div>
          )}
          { isSelectWorkersStep ? (
            <WorkersListComponent
              workersList={workersList}
              selectedWorkersIds={selectedWorkersIds}
              selectAllWorkers={this.selectAllWorkers}
              handleWorkerSelection={this.handleWorkerSelection}
              showNextStep={this.showNextStep}
            />
          ) : (
            <section className='tip-rate-section'>
              <WorkersPreviewPhotosList selectedWorkers={selectedWorkers} />
              { isTipModal ? (
                <TipAmount
                  addTips={this.addTips}
                />
              ) : isRateModal ? (
                <SelectRating
                  rateWorkers={this.rateWorkers}
                  isWorkersToAddFavorite={this.isWorkersToAddFavorite()}
                />
              ) : null }
            </section>
          )}
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/TipsAndRates/TipRateModal.js